<template>
    <div class="container mt-100 mt-60">
        <div class="row justify-content-center">
            <div class="col-12">
                <div class="section-title text-center mb-4 pb-2">
                    <span class="badge rounded-pill bg-soft-primary mb-3">Read News</span>
                    <h4 class="title mb-4">Latest News & Blogs</h4>
                    <p class="text-muted mx-auto para-desc mb-0">Great doctor if you need your family member to get
                        effective immediate assistance, emergency treatment or a simple consultation.</p>
                </div>
            </div><!--end col-->
        </div><!--end row-->

        <div class="row">
            <div v-for="item in datas" :key="item" class="col-lg-4  col-md-6 col-12 mt-4 pt-2">
                <div class="card blog blog-primary border-0 shadow rounded overflow-hidden">
                    <img :src="item.image" class="img-fluid" alt="">
                    <div class="card-body p-4">
                        <ul class="list-unstyled mb-2">
                            <li class="list-inline-item text-muted small me-3"><i
                                    class="uil uil-calendar-alt text-dark h6 me-1"></i>{{item.day}}</li>
                            <li class="list-inline-item text-muted small"><i
                                    class="uil uil-clock text-dark h6 me-1"></i>{{item.time}}</li>
                        </ul>
                        <router-link :to="{name: 'blog-detail', params: {id: item.id}}" class="text-dark title h5">{{ item.title }}</router-link>
                        <div class="post-meta d-flex justify-content-between mt-3">
                            <ul class="list-unstyled mb-0">
                                <li class="list-inline-item me-2 mb-0"><a href="#" class="text-muted like"><i
                                            class="mdi mdi-heart-outline me-1"></i>33</a></li>
                                <li class="list-inline-item"><a href="#" class="text-muted comments"><i
                                            class="mdi mdi-comment-outline me-1"></i>08</a></li>
                            </ul>
                            <router-link :to="{name: 'blog-detail', params: {id: item.id}}" class="link">Read More <i
                                    class="mdi mdi-chevron-right align-middle"></i></router-link>
                        </div>
                    </div>
                </div>
            </div><!--end col-->

        </div><!--end row-->
    </div><!--end container-->
</template>

<script setup>
import {ref} from 'vue';

const datas = ref([
    {
        id: 1,
        image: require('../assets/images/blog/01.jpg'),
        day: '20th November, 2020',
        time: '5 min read',
        title: 'You can easily connect to doctor and make a treatment'
    },
    {
        id: 2,
        image: require('../assets/images/blog/02.jpg'),
        day: '20th November, 2020',
        time: '5 min read',
        title: 'Lockdowns lead to fewer people seeking medical care'
    },
    {
        id: 3,
        image: require('../assets/images/blog/03.jpg'),
        day: '20th November, 2020',
        time: '5 min read',
        title: 'Emergency medicine research course for the doctors'
    },
])
</script>

<style lang="scss" scoped></style>